import React from "react";

import { faLayerGroup } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonStandard } from "@performyard/py-components";
import type { TemplateLibraryEntryTypeEnum } from "@performyard/service-contracts";

import { TYPE_META, TYPE_ORDER } from "../type-meta";

type Props = {
	selected: TemplateLibraryEntryTypeEnum | undefined;
	onChange: (next: TemplateLibraryEntryTypeEnum | undefined) => void;
	counts: Record<TemplateLibraryEntryTypeEnum, number>;
};

export const TemplateLibraryFilterPills = ({ selected, onChange, counts }: Props): React.ReactElement => {
	const total = TYPE_ORDER.reduce((sum, type) => sum + (counts[type] ?? 0), 0);
	const options = [
		{ value: undefined, label: "All", icon: faLayerGroup, count: total },
		...TYPE_ORDER.map((value) => ({
			value,
			label: TYPE_META[value].plural,
			icon: TYPE_META[value].icon,
			count: counts[value] ?? 0,
		})),
	];
	return (
		<div className="flex flex-wrap gap-2" role="group" aria-label="Filter library by type">
			{options.map(({ value, label, icon, count }) => (
				<div key={value ?? "all"}>
					<ButtonStandard
						variant="outline"
						color={selected === value ? "primary" : "neutral"}
						iconLeft={icon}
						aria-pressed={selected === value}
						onClick={() => onChange(value)}
					>
						<span>{label}</span>
						<span className="pl-1 tabular-nums">{count}</span>
					</ButtonStandard>
				</div>
			))}
		</div>
	);
};

export default TemplateLibraryFilterPills;
